var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.filterComponent,_vm._b({tag:"component",on:{"filter-selected":function($event){return _vm.$emit('filter-selected', { item: _vm.item, value: $event })}}},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }